export enum LoginModes {
  login = 'login',
  signup = 'signup',
}
